'use client';

/**
 * The error boundary. A client component by necessity — an error boundary has
 * to be one — so its copy cannot come from the server-resolved catalogue and is
 * kept to what the shell around it makes redundant anyway.
 *
 * <p>Renders WITHOUT chrome: the shell is fetched per request, and a shell
 * fetch is one of the things that can have failed to get us here.
 */
export default function StorefrontError({ reset }: { error: Error; reset: () => void }) {
  return (
    <div className="mx-auto flex w-full max-w-layout flex-col items-start gap-3 px-4 py-16">
      <h1 className="text-3xl font-semibold">Something went wrong</h1>
      <p className="text-[var(--color-text-secondary)]">
        This page could not be loaded. Please try again.
      </p>
      <button
        type="button"
        onClick={reset}
        className="min-h-11 rounded-md bg-[var(--color-brand-500)] px-4 text-[var(--color-text-on-brand)] focus-visible:outline-2 focus-visible:outline-offset-2"
      >
        Try again
      </button>
    </div>
  );
}
